import IPresentation from '@app/types/presentations/presentation/IPresentation';
import IPresentationMaster from '@app/types/presentations/master/IPresentationMaster';
import ISlideSettings from '@app/types/presentations/presentation/ISlideSettings';
import SlideUtil from '@app/utils/SlideUtil';

export default class PresentationUtil {
	public static hasExpiredSelectedSlides(
		presentation: IPresentation,
		presentationMaster: IPresentationMaster
	): boolean {
		return presentation.settings.slides.some(
			(slideSettings: ISlideSettings): boolean =>
				slideSettings.selected &&
				SlideUtil.isSlideUnpublished(
					presentationMaster.slidesById[slideSettings.id] || presentation.customSlidesById[slideSettings.id]
				)
		);
	}
}
